import { axiosSubscriptionInstance } from "../configs/AxiosInstance";

//! PLAN DATA - event_type_id must be from sessionUtils (e.g. modify_user_profile for current app) so user-profile accepts add_session_event
export const fetchUserPlans = async (get, event_type_id) => {
  try {
    if (!event_type_id) {
      console.warn("fetchUserPlans: event_type_id required for session logging");
    }
    const query = event_type_id
      ? `/fetch-all-plans?event_type_id=${event_type_id}`
      : "/fetch-all-plans";
    const response = await get(query, {
      instance: axiosSubscriptionInstance,
    });

    const plans = response?.data?.plans || [];

    return plans.map((plan) => ({
      planId: plan.id,
      planName: plan.plan_name,
      planDetails: plan.details 
        ? plan.details.split(',').map(d => d.trim()).filter(d => d)
        : [],
      requiredEmployees: [],
      pricing: plan.pricings.map((pricing) => ({
        planPricingId: pricing.id,
        plan_id: plan.id,
        duration: Math.floor(pricing.plan_duration_days / 30),
        planDurationDays: pricing.plan_duration_days ?? null,
        price: pricing.price,
        maxDiscount: pricing.max_discount_percent,
        country: pricing.country?.name || "-",
        currency: pricing.denomination?.symbol || "-",
        countryId: pricing.country?.id,
        denominationId: pricing.denomination?.id,
      })),
    }));
  } catch (err) {
    console.error("Error fetching user plans:", err);
    throw err;
  }
};
// PLAN CREATION
export const createPlan = async (post, payload) => {
  try {
    return await post("/modify-plans", payload, {
      instance: axiosSubscriptionInstance,
    });
  } catch (err) {
    console.error("Error creating plan:", err);
    throw err;
  }
};

// PLAN UPDATION
export const updatePlan = async (post, payload) => {
  try {
    return await post("/modify-plans", payload, {
      instance: axiosSubscriptionInstance,
    });
  } catch (err) {
    console.error("Error updating plan:", err);
    throw err;
  }
};

// PRICING PLAN CREATION
export const createPricingPlan = async (post, payload) => {
  try {
    // payload = { plan_id, duration, price, max_discount, country, currency}
    return await post("/modify-plan-pricings", payload, {
      instance: axiosSubscriptionInstance,
    });
  } catch (err) {
    console.error("Error creating pricing plan:", err);
    throw err;
  }
};

// PRICING PLAN UPDATION
export const updatePricingPlan = async (post, plan_id, payload) => {
  try {
    // payload = { plan_id, duration, price, max_discount, country, currency }
    return await post(`/modify-plan-pricings`, payload, {
      instance: axiosSubscriptionInstance,
    });
  } catch (err) {
    console.error("Error updating pricing plan:", err);
    throw err;
  }
};
